<template>
  <introduction v-if="currentFlowStep === signupFlowSteps.enterDetails"
                :next="() => setCurrentFlowStep(signupFlowSteps.enterCode)"/>
  <signup-enter-code v-else-if="currentFlowStep === signupFlowSteps.enterCode"
                     :next="onEnterCode"/>
  <whatsapp-opt-in v-else-if="currentFlowStep === signupFlowSteps.whatsappOptin && !syncOnboarding"
                   :next="gotToOnboard" />
</template>

<script>

import { mapState, mapGetters, mapMutations } from 'vuex';
import Introduction from './steps/Introduction.vue';
import SignupEnterCode from './steps/SignupEnterCode.vue';
import WhatsappOptIn from './steps/WhatsappOptIn.vue';
import router from '../../../../../router';
import featureFlag from '../../../../../api/featureFlag';

export default {
  name: 'Signup',
  components: {
    WhatsappOptIn,
    Introduction,
    SignupEnterCode,
  },
  async created() {
    this.setCurrentFlowStep(this.signupFlowSteps.enterDetails);
  },
  data() {
    return {
      syncOnboarding: false,
    };
  },
  computed: {
    ...mapState('signup', ['currentFlowStep', 'SIGNUP_ERRORS', 'error']),
    ...mapGetters('signup', ['signupFlowSteps']),
  },
  methods: {
    ...mapMutations('signup', ['setCurrentFlowStep']),
    gotToOnboard() {
      router.push({ path: '/onboard' });
    },
    async onEnterCode() {
      this.syncOnboarding = (await featureFlag.getTreatment('sync-onboarding')) === 'on';
      if (this.syncOnboarding) {
        router.push({ path: '/ob' });
      } else {
        this.setCurrentFlowStep(this.signupFlowSteps.whatsappOptin);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
